module.exports = __webpack_public_path__ + "img/Icon_Manejo_de_Citas_Provider.c184dd07.svg";